import {Component, Injectable} from '@angular/core';
import {  CanActivate, Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,  CanActivateChild } from '@angular/router';
import { AuthService } from './auth.service';
//import { AuthenticationService } from './authentication.service';

@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild {

  constructor(private authService: AuthService, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    /*console.log('AuthGuard#canActivate called');
    return true;*/
    let url: string = state.url;
    let navigationMenuID = state.root.children[0].children[0].data.id;
    return this.checkLogin(url, navigationMenuID);
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.canActivate(route, state);
  }

  checkLogin(url: string, navigationMenuID: number): boolean {
    if (this.authService.isLoggedIn) { return true; }

    // Store the attempted URL for redirecting
    this.authService.redirectUrl = url;

    // Navigate to the login page with extras
    //this.router.navigate(['pages/login']);
    return false;
  }

  /*checkUserGroupAccessRights() {
    var that = this;
    this.authenticationService.checkUserGroupAccessRights().get({companyID: localStorage.getItem('selectedCompany'), navigationMenuID: this.navigationMenuID}).subscribe((data) => {
      this.authenticationService.setUserGroupAccessRights(data.data.data);
      var accessRights = data.data.data;
      if(accessRights.readonly){
        console.log('You have access')
      }

    }, (error) => {

    });
  }*/

}



// WEBPACK FOOTER //
// /app/src/app/services/auth-guard.service.ts